export default {
   components: {},
   routes: [
      {
         path: '*',
         component: () => import(`./pages/four-zero-four`),
         name: 'FourZeroFour'
      },
   ]
}